import MissingBarcodeMessage from './MissingBarcodeMessage';

export default MissingBarcodeMessage;
